"use client";

import dynamic from "next/dynamic";
import { FC } from "react";
import { StickyHeaderProps } from "./StickyHeader.interface";
import BFLLazyLoad from "@repo/shared-ui/BFLLazyLoad";

const RenderStickyHeader = dynamic(
  () => import("./StickyHeader.tsx").then((m) => m.default),
  { ssr: false },
);

const StickyHeaderWrapper: FC<StickyHeaderProps> = ({ content, version }) => {
  return (
    <BFLLazyLoad triggerOnScroll={true}>
      <RenderStickyHeader version={version} content={content} />
    </BFLLazyLoad>
  );
};

export default StickyHeaderWrapper;
